var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Contact Information ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-2"
                    },
                    [
                      _vm._v(
                        " Enter the contact information for your " +
                          _vm._s(_vm.websitetype) +
                          ". "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "email",
                        expression: "'email'"
                      }
                    ],
                    attrs: {
                      name: "email",
                      label: "Email Address",
                      autocomplete: "new-password",
                      "data-vv-as": "Email Address",
                      "error-messages": _vm.errors.collect("email")
                    },
                    model: {
                      value: _vm.email,
                      callback: function callback($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "phone",
                        expression: "'phone'"
                      }
                    ],
                    attrs: {
                      label: "Phone Number",
                      name: "phone",
                      autocomplete: "new-password",
                      "data-vv-as": "Phone Number",
                      "error-messages": _vm.errors.collect("phone")
                    },
                    model: {
                      value: _vm.phone,
                      callback: function callback($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    attrs: {
                      label: "Facebook Link",
                      name: "facebook"
                    },
                    model: {
                      value: _vm.facebook,
                      callback: function callback($$v) {
                        _vm.facebook = $$v
                      },
                      expression: "facebook"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    attrs: {
                      label: "Twitter Link",
                      name: "twitter"
                    },
                    model: {
                      value: _vm.twitter,
                      callback: function callback($$v) {
                        _vm.twitter = $$v
                      },
                      expression: "twitter"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    attrs: {
                      label: "Instagram Link",
                      name: "instagram"
                    },
                    model: {
                      value: _vm.instagram,
                      callback: function callback($$v) {
                        _vm.instagram = $$v
                      },
                      expression: "instagram"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    attrs: {
                      label: "LinkedIn Link",
                      name: "linkedin"
                    },
                    model: {
                      value: _vm.linkedin,
                      callback: function callback($$v) {
                        _vm.linkedin = $$v
                      },
                      expression: "linkedin"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }